import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack } from "@mui/material";
import { FC } from "react";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { useEnum } from "@/api/services/global/enum";
import { JobInfoItem } from "@/features/job/components/job-detail/JobInfoItem";
import { findLabelByValue } from "@/utils/object";
import { convertNumberToCommas } from "@/utils/input";

type TJobEmploymentConditionDetailProps = {
  defaultValues?: Partial<TJobForm>;
  isDraft ?: boolean,
};

export const JobEmploymentConditionDetail: FC<TJobEmploymentConditionDetailProps> = ({ defaultValues, isDraft }) => {
  const { data: employmentTypeOptions } = useEnum("EEmploymentType");
  const { data: salaryTypeOptions } = useEnum("ESalaryType");
  const { data: yesNoPendingStatusOptions } = useEnum("EYesNoPendingStatus");

  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="雇用条件" />} padding="24px" showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <JobInfoItem label="業務内容" value={defaultValues?.businessContent} type="textArea" />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="雇用形態" value={findLabelByValue(employmentTypeOptions, defaultValues?.employmentType)} required={!isDraft} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="給与形態" value={findLabelByValue(salaryTypeOptions, defaultValues?.salaryType)} />
          </Grid>

          {defaultValues?.jobSalarySummaries?.map((summary, index) => (
            <Grid item xs={12} key={index}>
              <InnerBox title={`総支給額${index + 1}`} padding="16px" showDivider={false}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <JobInfoItem
                      label="総支給額"
                      value={summary.totalAmount !== null && summary.totalAmount !== undefined ? `${convertNumberToCommas(summary.totalAmount.toString())}円` : ""}
                      required={!isDraft}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <JobInfoItem label="総支給額の内訳" value={summary.totalAmountBreakdown} type="textArea" />
                  </Grid>
                  <Grid item xs={12}>
                    <JobInfoItem
                      label="控除金額"
                      value={summary.deductionAmount !== null && summary.deductionAmount !== undefined ? `${convertNumberToCommas(summary.deductionAmount.toString())}円` : ""}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <JobInfoItem label="控除内容の詳細" value={summary.deductionDetail} type="textArea" />
                  </Grid>
                  <Grid item xs={12}>
                    <JobInfoItem
                      label="目安手取り金額"
                      value={summary.netSalaryEstimate !== null && summary.netSalaryEstimate !== undefined ? `${convertNumberToCommas(summary.netSalaryEstimate.toString())}円` : ""}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <JobInfoItem label="手取り金額計算背景" value={summary.netSalaryEstimateNote} type="textArea" isShowDivider={false} />
                  </Grid>
                </Grid>
              </InnerBox>
            </Grid>
          ))}
          <Grid item xs={12}>
            <JobInfoItem label="その他手当の内容" value={defaultValues?.otherAllowanceDescription} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="残業に関する説明" value={defaultValues?.overtimeDescription} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="賞与" value={findLabelByValue(yesNoPendingStatusOptions, defaultValues?.bonus)} required={!isDraft} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="賞与時期・金額" value={defaultValues?.bonusInfo} type="textArea" />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="昇給" value={findLabelByValue(yesNoPendingStatusOptions, defaultValues?.salaryRaise)} required={!isDraft} />
          </Grid>
          <Grid item xs={6}>
            <JobInfoItem label="昇給時期" value={defaultValues?.salaryRaiseTime} />
          </Grid>
          <Grid item xs={12}>
            <JobInfoItem label="雇用条件に関する補足事項" value={defaultValues?.employmentConditionNote} type="textArea" isShowDivider={false} />
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
